import React, { useCallback, useEffect, useState } from 'react';

import DateFnsUtils from '@date-io/date-fns';
import {
  Box,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import deLocale from 'date-fns/locale/es';

import { ReactComponent as CalendarIcon } from '../../../../../../assets/img/calendar.svg';
import { ReactComponent as TimeIcon } from '../../../../../../assets/img/reloj.svg';
import FloatingButton from '../../../../../../components/FloatingButton';
import Loader from '../../../../../../components/LoaderSplash/Loader.component';
import { useSinisterInspectionsContext } from '../../../../../../context/SinisterInspections/SinisterInspections.provider';
import useForm from '../../../../../../helpers/useForm';
import SelectDateValidations from './Step2.validations';

const Step2 = () => {
  const {
    loading,
    step,
    goBack,
    nextStep,
    sinister_inspection_body,
    updateSinisterInspectionBody,
  } = useSinisterInspectionsContext();

  const [selectedDate, setSelectedDate] = React.useState(new Date(Date.now()));
  const [defaultValues, setDefaultValues] = useState({
    selectedDate: '',
    from: '08:00',
    to: '18:00',
  });

  useEffect(() => {
    const availableDate = currentDate();
    setSelectedDate(availableDate);
  }, []);

  const handleDateChange = (date: any) => {
    if (date > new Date()) {
      setSelectedDate(date);
    } else {
      setSelectedDate(date);
    }
  };

  const minDate = () => {
    let date = new Date(Date.now());
    date.setDate(date.getDate() + 3);
    return date;
  };

  const maxDate = () => {
    let date = new Date(Date.now());
    date.setDate(date.getDate() + 30);
    return date;
  };

  const currentDate = () => {
    let date = new Date(Date.now());

    for (let i = 0; i < 4; i++) {
      if (date.getDay() === 6) {
        date.setDate(date.getDate() + 2);
        i--;
      } else {
        date.setDate(date.getDate() + 1);
      }
    }
    return date;
  };

  const callNextStep = useCallback(
    () => {
      if (selectedDate && values.from && values.to) {
        updateSinisterInspectionBody({
          ...values,
          selectedDate,
        });
        nextStep();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [nextStep, selectedDate, updateSinisterInspectionBody]
  );

  const { values, errors, handleChange, handleSubmit } = useForm(
    callNextStep,
    SelectDateValidations,
    defaultValues
  );

  const disableWeekends = (date) => {
    const day = date.getDay();
    if (day === 6 || day === 0) {
      return true;
    }
  };

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando información'}></Loader>
      </Box>

      <Grid container justify="center">
        <Grid item xs={12} /* sm={6} md={4} lg={3} */>
          <Box my={4}>
            <Typography variant="h6">
              Día y rango horario para la inspección
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={12}>
          <Grid container>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Grid item xs={12} sm={5}>
                <Box mb={2}>
                  <Typography
                    variant="subtitle2"
                    style={{ marginBottom: '-8px' }}
                  >
                    Fecha *
                  </Typography>
                  <KeyboardDatePicker
                    style={{ backgroundColor: 'white' }}
                    disableToolbar
                    variant="inline"
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker"
                    value={selectedDate}
                    onChange={handleDateChange}
                    minDate={minDate()}
                    maxDate={maxDate()}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    keyboardIcon={<CalendarIcon />}
                    invalidLabel={'Formato de fecha inválido'}
                    invalidDateMessage={'Formato de fecha inválido'}
                    InputProps={{ readOnly: true }}
                    fullWidth
                    shouldDisableDate={disableWeekends}
                  />
                </Box>
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={12}>
          <Grid container style={{ columnGap: '20px' }}>
            <Grid item xs={12} sm={5}>
              <Box mb={2}>
                <Typography variant="subtitle2" style={{ marginBottom: '8px' }}>
                  De
                </Typography>
                <TextField
                  type="text"
                  size="small"
                  onChange={handleChange}
                  fullWidth={true}
                  name="from"
                  id="from"
                  //placeholder="De"
                  variant="outlined"
                  value={values.from}
                  defaultValue="08:00"
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <TimeIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm={5}>
              <Box mb={2}>
                <Typography variant="subtitle2" style={{ marginBottom: '8px' }}>
                  A
                </Typography>
                <TextField
                  type="text"
                  size="small"
                  onChange={handleChange}
                  fullWidth={true}
                  name="to"
                  id="to"
                  //placeholder="A"
                  variant="outlined"
                  value={values.to}
                  defaultValue="18:00"
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <TimeIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={12}>
          <Box>
            <Typography>
              * A partir de las 72 hs hábiles del día de la fecha
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={12}>
          <Box my={4}>
            <FloatingButton
              onClick={handleSubmit}
              //disabled={!selectedDate}
            >
              Continuar
            </FloatingButton>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Step2;
